<template lang="pug">
  div
    .form-group
      label.col-sm-3.control-label CSVファイル
        span.bcard-required (*)
      .col-sm-9
        file-droppable(v-model="csvFiles", type="csv", :multi="false", :required="true", :edit_mode="true")

    .form-group
      label.col-sm-3.control-label(for="title_except") タイトル行
      .col-sm-9
        .radio.radio-rich
          label
            input(type="radio" name="title_except", :value="app_flag.ON", checked)
            span: i.fa.fa-dot-circle-o.fa-lg
            | あり (2 行目 からデータ行)
          |
          | &nbsp;
          |
          label
            input(type="radio" name="title_except", :value="app_flag.OFF")
            span: i.fa.fa-dot-circle-o.fa-lg
            | なし (1 行目 からデータ行)

    export-settings(ref="exportSettings")
</template>

<script>
import fileDroppable from '@/components/organisms/FileDroppable'
import ExportSettings from '@/components/organisms/ExportSettings'

export default {
  name: 'ImportSettings',
  components: { fileDroppable, ExportSettings },
  props: {
    value: {
      type: Object,
      required: true,
      default: function () {
        return {
          csvFile: null
        }
      }
    }
  },
  computed: {
    csvFiles: {
      get: function () {
        return this.value.csvFile ? [this.value.csvFile] : []
      },
      set: function (csvFiles) {
        this.$emit('input', {
          csvFile: csvFiles.pop() || null
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/ImportSettings.vue